export default __webpack_public_path__ + "static/media/confirm-success-books.1fe6321d.webp";